import { render, staticRenderFns } from "./EditDocuments.vue?vue&type=template&id=7572148d&scoped=true"
import script from "./EditDocuments.vue?vue&type=script&lang=js"
export * from "./EditDocuments.vue?vue&type=script&lang=js"
import style0 from "./EditDocuments.vue?vue&type=style&index=0&id=7572148d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7572148d",
  null
  
)

export default component.exports